import React from 'react';
import { Chart } from 'react-google-charts';
import WrapperCard from './WrapperCard';

const options = {
  legend: { position: 'bottom', alignment: 'start' },
  chartArea: {
    left: 40,
    right: 15,
    top: 10,
    bottom: 50,
  },
  curveType: 'function',
  series: {
    0: { color: '#48cae4' },
    1: { color: '#0077b6' },
  },
  pointsVisible: true,
  hAxis: {
    minorGridlines: { count: 0 },
  },
  vAxis: {
    format: 'short',
  },
};

function TotalCallsByDay({ isLoading, data }) {
  const inbound10DayCalls = data?.inbound_count || [];
  const outbound10DayCalls = data?.outbound_count || [];

  const chartData = React.useMemo(() => {
    const preparedArray = [];

    for (let i = 0; i < inbound10DayCalls?.length; i++) {
      const curr = inbound10DayCalls[i];
      const inboundKey = curr?.key_as_string;
      const inboundCalls = curr?.doc_count;

      preparedArray.push([{ v: inboundKey, f: inboundKey }, inboundCalls, 0]);
    }

    for (let i = 0; i < outbound10DayCalls?.length; i++) {
      const curr = outbound10DayCalls[i];
      const outboundKey = curr?.key_as_string;
      const outboundCalls = curr?.doc_count;

      const index = preparedArray.findIndex(pA => {
        return pA[0].f === curr?.key_as_string;
      });

      if (index !== -1) {
        preparedArray[index][2] = outboundCalls;
      } else {
        preparedArray.push([{ v: outboundKey, f: outboundKey }, 0, outboundCalls]);
      }
    }

    return [['Date', 'Inbound', 'Outbound'], ...preparedArray];
  }, [inbound10DayCalls, outbound10DayCalls]);

  return (
    <WrapperCard
      isLoading={isLoading}
      title="Total Calls By Day"
      contentSkeletons={6}
      headerTooltip="Total calls by day for the last 7 days broken out by inbound and outbound calls"
    >
      {chartData?.length > 1 ? (
          <Chart chartType="LineChart" width="100%" height="249px" data={chartData} options={options} />
        ) : (
          <div style={{ textAlign: 'center', padding: '20px' }}>No data available</div>
        )
      }
    </WrapperCard>
  );
}

export default TotalCallsByDay;
